import { useState, useEffect } from "react";
import useWindowDimensions from "../helpers/window";

/**
 * Hook that calculates the available content height below the header.
 * Subtracts the header height (text size + padding + border) from the viewport height.
 *
 * Header height breakdown:
 *  - headerTextSize: 18px (<768), 20px (<1920), 22px (≥1920)
 *  - line-height extra: 2px
 *  - vertical padding: 2 * 9 = 18px
 *  - border-bottom: 1px
 */
const useContentsHeight = () => {
  const { width, height } = useWindowDimensions();
  const [contentsHeight, setContentsHeight] = useState(height);

  useEffect(() => {
    const headerTextSize = height < 768 ? 18 : height < 1920 ? 20 : 22;
    const headerHeight = headerTextSize + 2 + 2 * 9 + 1;
    setContentsHeight(height - headerHeight);
  }, [width, height]);

  return contentsHeight;
};

export default useContentsHeight;
